import { RootState } from "redux/store";
import { Link } from "react-router-dom";
import { Table, Title } from "components";
import { useEffect, useCallback } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getPriceGroups, deletePriceGroups, updatePriceGroupField } from "redux/slices/PriceGroups";

export function PriceGroupOld() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const priceGroups: any = useAppSelector((state: RootState) => state.priceGroups);
    const user = useAppSelector((state: RootState) => state.logedinUser);

    const columns = [
        {
            Header: "Name",
            accessor: "name",
            defaultCanSort: true,
            width: 1300,
            Cell: (row: any) => <Link to={`/app/price-group/${row.cell.row.original.id}`}>{row.value}</Link>,

        },
    ];

    useEffect(() => {   
        dispatch(getPriceGroups());
    }, []);

    function handleDelete() {
        let priceGroupIds = priceGroups.selectedRows.map((row: any) => priceGroups.table[row].id );
        dispatch(deletePriceGroups(priceGroupIds)).then(() => {
            dispatch(getPriceGroups());
        });
    }

    const selectedRows = useCallback((pageIndex:any) => {
		dispatch(updatePriceGroupField({ key: "selectedRows", value: pageIndex }));
	}, []);

    return (
        <>
            <Title pageTitle="Price Groups" />
            <Row>
                <Col xs={12}>
                    <Card>
                        <Card.Body>
                            <Row className="mb-1 ps-1 pe-1">
                                <div className="page-container">
                                <Table
                                    pageSize={15}
                                    isSortable={true}
                                    pagination={true}
                                    isSelectable={true}
                                    isSearchable={true}
                                    disableExport={true}
                                    columns={columns}
                                    errors={priceGroups.error}
                                    data={priceGroups.table}
                                    selectedRows={selectedRows}
                                    loading={priceGroups.loading}
                                    reloadTableRows={() => dispatch(getPriceGroups())}
                                    addNewRow={user.permissions.priceGroups.canCreate ? () => navigate("/app/new-price-group") : undefined }
                                    removeRows={user.permissions.priceGroups.canDelete ? handleDelete : undefined}
                                />
                                </div>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
}